import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import Vuetify from 'vuetify'
import router from './routes'
import store from './store/store'
import FirebaseAuthPlugin from './firebase/'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(FirebaseAuthPlugin)
Vue.use(Vuetify)
Vue.use(VueMeta)

sync(store, router)

new Vue({
  mounted: function() {
    this.$vuetify.theme.primary = '#008D70';
    this.$vuetify.theme.secondary = '#F1CE3E';
    this.$vuetify.theme.upvote = '#F1CE3E';
    this.$vuetify.theme.titles = '#014A3C';
    // this.$vuetify.theme.chatbackground = '#A3A8A6';
    this.$vuetify.theme.chatbackground = '#a8d4cf'
    this.$vuetify.theme.search = '#edefee'

    this.$vuetify.theme.danger = '#5e5e5e';
    this.$vuetify.theme.success = '#008000';
},
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export { router, store }
